export const environment = {
  production: false,
  url: 'https://oxhw29n9bf.execute-api.eu-central-1.amazonaws.com/v1/',
  presignedUrlEndpoint: 'https://oxhw29n9bf.execute-api.eu-central-1.amazonaws.com/v1/get-signed-url',
}
